// v2

var portalCorrectPassword = 'myloartist';
var portalArtworkCount = 1;

document.addEventListener('DOMContentLoaded', function() {
  if (localStorage.getItem('myloPortalAuth') === 'true') {
    document.getElementById('portalPasswordForm').style.display = 'none';
    document.getElementById('portalContent').classList.add('visible');
  }
  document.getElementById('portalPassword').addEventListener('keypress', function(e) {
    if (e.key === 'Enter') { portalCheckPassword(); }
  });
});

function portalCheckPassword() {
  var entered = document.getElementById('portalPassword').value;
  if (entered === portalCorrectPassword) {
    localStorage.setItem('myloPortalAuth', 'true');
    document.getElementById('portalPasswordForm').style.display = 'none';
    document.getElementById('portalContent').classList.add('visible');
  } else {
    document.getElementById('portalErrorMsg').style.display = 'block';
  }
}

function portalShowUpload() {
  var name = document.getElementById('portalArtistName').value.trim();
  var email = document.getElementById('portalArtistEmail').value.trim();
  if (!name || !email) {
    alert('Please enter your name and email address to continue.');
    return;
  }
  document.getElementById('portalUploadArea').classList.add('visible');
}

function portalShowArtworks() {
  var checkbox = document.getElementById('portalUploadConfirm');
  if (checkbox.checked) {
    document.getElementById('portalArtworkArea').classList.add('visible');
  } else {
    document.getElementById('portalArtworkArea').classList.remove('visible');
  }
}

function portalSubmitForm() {
  var form = document.getElementById('portalArtworkForm');
  var formData = new FormData(form);
  fetch('https://api.web3forms.com/submit', {
    method: 'POST',
    body: formData
  })
  .then(function(r) { return r.json(); })
  .then(function(data) {
    if (data.success) {
      form.style.display = 'none';
      document.querySelector('.portal-inner .portal-text').style.display = 'none';
      document.getElementById('portalFormSuccess').style.display = 'block';
    } else {
      alert('There was a problem. Please try again or email info@myloart.co.uk');
    }
  })
  .catch(function() {
    alert('There was a problem. Please try again or email info@myloart.co.uk');
  });
}

function portalAddArtwork() {
  portalArtworkCount++;
  var container = document.getElementById('portalArtworkEntries');
  var entry = document.createElement('div');
  entry.className = 'portal-artwork-entry';
  entry.setAttribute('data-index', portalArtworkCount);
  var n = portalArtworkCount;
  var h = '';
  h += '\x3cdiv class="portal-artwork-header"\x3e';
  h += '\x3cdiv class="portal-artwork-number"\x3eArtwork ' + n + '\x3c/div\x3e';
  h += '\x3cbutton type="button" class="portal-remove-btn" onclick="portalRemoveArtwork(this)"\x3eRemove\x3c/button\x3e';
  h += '\x3c/div\x3e';
  h += '\x3cdiv class="portal-form-row"\x3e';
  h += '\x3clabel\x3eArtwork Title \x3cspan class="req"\x3e*\x3c/span\x3e\x3c/label\x3e';
  h += '\x3cinput type="text" name="artwork_' + n + '_title" required\x3e';
  h += '\x3c/div\x3e';
  h += '\x3cdiv class="portal-form-row"\x3e';
  h += '\x3clabel\x3eMedium \x3cspan class="req"\x3e*\x3c/span\x3e\x3c/label\x3e';
  h += '\x3cdiv class="helper"\x3ee.g. acrylic on canvas, oil on board, watercolour on paper\x3c/div\x3e';
  h += '\x3cinput type="text" name="artwork_' + n + '_medium" required\x3e';
  h += '\x3c/div\x3e';
  h += '\x3cdiv class="portal-form-row portal-form-row--short"\x3e';
  h += '\x3clabel\x3eHeight (cm) \x3cspan class="req"\x3e*\x3c/span\x3e\x3c/label\x3e';
  h += '\x3cinput type="number" name="artwork_' + n + '_height_cm" required\x3e';
  h += '\x3c/div\x3e';
  h += '\x3cdiv class="portal-form-row portal-form-row--short"\x3e';
  h += '\x3clabel\x3eWidth (cm) \x3cspan class="req"\x3e*\x3c/span\x3e\x3c/label\x3e';
  h += '\x3cinput type="number" name="artwork_' + n + '_width_cm" required\x3e';
  h += '\x3c/div\x3e';
  h += '\x3cdiv class="portal-form-row portal-form-row--medium"\x3e';
  h += '\x3clabel\x3eFraming \x3cspan class="req"\x3e*\x3c/span\x3e\x3c/label\x3e';
  h += '\x3cselect name="artwork_' + n + '_framing" required\x3e';
  h += '\x3coption value="" disabled selected\x3eSelect\x3c/option\x3e';
  h += '\x3coption value="Framed"\x3eFramed\x3c/option\x3e';
  h += '\x3coption value="Unframed"\x3eUnframed\x3c/option\x3e';
  h += '\x3c/select\x3e';
  h += '\x3c/div\x3e';
  h += '\x3cdiv style="display:flex;align-items:flex-end;gap:25px;flex-wrap:wrap;margin-bottom:22px;"\x3e';
  h += '\x3cdiv class="portal-form-row portal-form-row--short" style="margin-bottom:0;"\x3e';
  h += '\x3clabel\x3ePrice (GBP) \x3cspan class="req"\x3e*\x3c/span\x3e\x3c/label\x3e';
  h += '\x3cinput type="number" name="artwork_' + n + '_price_gbp" required\x3e';
  h += '\x3c/div\x3e';
  h += '\x3cdiv class="portal-radio-group"\x3e';
  h += '\x3clabel class="portal-radio"\x3e\x3cinput type="radio" name="artwork_' + n + '_price_type" value="Wall/selling price" required checked\x3e Wall/selling price\x3c/label\x3e';
  h += '\x3clabel class="portal-radio"\x3e\x3cinput type="radio" name="artwork_' + n + '_price_type" value="Price to you, the artist"\x3e Price to you, the artist\x3c/label\x3e';
  h += '\x3c/div\x3e';
  h += '\x3c/div\x3e';
  h += '\x3cdiv class="portal-form-row portal-form-row--wide"\x3e';
  h += '\x3clabel\x3eDescription or Notes\x3c/label\x3e';
  h += '\x3cdiv class="helper"\x3eOptional - any extra context about the piece\x3c/div\x3e';
  h += '\x3ctextarea name="artwork_' + n + '_description" placeholder="Tell us anything else about this artwork..."\x3e\x3c/textarea\x3e';
  h += '\x3c/div\x3e';
  entry.innerHTML = h;
  container.appendChild(entry);
}

function portalRemoveArtwork(btn) {
  var entry = btn.closest('.portal-artwork-entry');
  entry.remove();
  var entries = document.querySelectorAll('.portal-artwork-entry');
  entries.forEach(function(el, i) {
    el.querySelector('.portal-artwork-number').textContent = 'Artwork ' + (i + 1);
  });
}